import { Flex, Text } from '@chakra-ui/core';
import React from 'react';

const LineItem = ({ label, children, ...style }) => (
  <Flex justifyContent="space-between" {...style}>
    <Text fontWeight={500} fontSize="sm" color="#525252">
      {label}
    </Text>
    <Text fontWeight="bold" fontSize="sm" color="#262626">
      {children}
    </Text>
  </Flex>
);

export default LineItem;
